import { HsVector2 } from '../../math-new/objects/vector2.class';
import { HsControlAction } from './control-action.abstract';
import { HsControlActionType } from './control-action-type.enum';

export class HsRaycastControlAction extends HsControlAction {
  public readonly actionType: HsControlActionType = HsControlActionType.Raycast;
  constructor(public position: HsVector2 = new HsVector2(0, 0)) {
    super();
    this.isActive = true;
  }

  public getValuesFrom(controlAction: HsControlAction): void {
    if (!(controlAction instanceof HsRaycastControlAction)) {
      return;
    }

    this.position.copy(controlAction.position);
    this.isActive = true;
  }
}
